module.exports = __webpack_public_path__ + "7d1ef799c54ee6ba5750081e1d337e4f.pdf";